window.addEventListener('load', () => {
  init();
})

const init = () => {
  const blocks = document.querySelectorAll('[data-block-id="support-block"]');
  if (blocks) {
    blocks.forEach(block => {
      if (block.children) {
        Array.from(block.children).forEach(item => {
          let btn = item.querySelector('button');
          btn.addEventListener('click', e => {
            let new_aria_expanded = e.currentTarget.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
            e.currentTarget.setAttribute("aria-expanded", new_aria_expanded);
            
            let item_body = item.querySelector(`dd[id="${e.currentTarget.getAttribute('aria-controls')}"]`);
            let item_arrow = item.querySelector(`svg`);
            
            if (new_aria_expanded === "true") {
              item_body.classList.remove('hidden');
              item_arrow.classList.remove('-rotate-90');
              item_arrow.classList.add('rotate-0');
            } else {
              item_body.classList.add('hidden');
              item_arrow.classList.remove('rotate-0');
              item_arrow.classList.add('-rotate-90');
            }
          })
        }); 
      }
    });
  }
}